import { useQuery } from "@tanstack/react-query";
import calendarEventApiClient, {
  CalendarEvent,
} from "../../../api/calendarEvent";

const useKlydoScheduledEvent = (klydoId: string) => {
  return useQuery<CalendarEvent | null>({
    queryKey: ["klydo-scheduled-event", klydoId],
    queryFn: async () => {
      const events = await calendarEventApiClient.getCalendarEvents({
        klydoId,
      });
      return events[0] ?? null;
    },
    enabled: !!klydoId,
  });
};

export default useKlydoScheduledEvent;
